module.exports = __webpack_public_path__ + "static/media/3-2-bicovan.b7700305.jpg";